import styled from 'styled-components';

export const Div = styled.div`
    width: 100%;
    height: 100%;
    max-width: 600px;
    max-height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: auto;
        max-width: 600px;
    }

    @media (max-width: 960px) {
        max-width: 400px;
        max-height: 350px;
    }

    @media (max-width: 640px) {
        max-width: 300px;
        max-height: 250px;
    }
`